import React from 'react';
import PropTypes from 'prop-types';
import NodeContentHeaderTools from '../NodeContentHeaderTools';
import { LoopTopSection, CollapsedDescription } from './styles';

const TopSection = ({ panel, options, nodeData, collapsedDescription, showDescription, translations }) => {
  const { userToken, viewer } = options;

  return (
    <LoopTopSection collapsedDescription={collapsedDescription}>
      {collapsedDescription && (
        <CollapsedDescription onClick={showDescription}>
          {translations.viewer.circle_description_header}
        </CollapsedDescription>
      )}
      <NodeContentHeaderTools
        userToken={userToken}
        nodeData={nodeData}
        panel={panel}
        viewer={viewer}
        showVoiceOverTool={true}
        darkMode={true}
      />
    </LoopTopSection>
  );
};

export default TopSection;

TopSection.propTypes = {
  panel: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  nodeData: PropTypes.object.isRequired,
  collapsedDescription: PropTypes.bool.isRequired,
  showDescription: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
};
